import {isEqual, orderBy} from 'lodash';
import PropTypes from 'prop-types';
import React, {Component, Fragment} from 'react';
import {Col, Row} from 'react-bootstrap';
import * as Table from 'reactabular-table';
import * as Virtualized from 'reactabular-virtualized';
import {compose} from 'redux';
import * as search from 'searchtabular';
import * as sort from 'sortabular';
import * as resolve from 'table-resolver';
import {buildColumns} from 'libs/datatable';
import './styles.scss';


export default class DataTableVirtualized extends Component {
  constructor(props) {
    super(props);

    this.state = {
      query: {},
      rows: props.rows,
      columns: props.columns,
    };

    this._tableHeader = null;
    this._tableBody = null;

    this._buildColumns = buildColumns.bind(this);
  }

  componentDidMount() {
    this._buildColumns(this.props.columns, false);
  }

  componentDidUpdate(prevProps) {
    const {
      tableHeight,
      rows,
    } = this.props;

    if (!isEqual(rows, prevProps.rows)) {
      this.setState({rows});
    }

    if ((tableHeight !== undefined) && (this.state.tableHeight !== tableHeight)) {
      this.setState({tableHeight: tableHeight});
    }

    if (document.querySelector('[data-component="DataTableVirtualized"] thead')) {
      const headerHeight = document.querySelector('[data-component="DataTableVirtualized"] thead').offsetHeight;
      document.querySelector('[data-component="DataTableVirtualized"] .table-container').style.height = `${tableHeight + headerHeight}px`;
    }
  }

  render() {
    const {
      noResultText,
      searchColumn,
      onRow,
      optionalFooter,
      maxHeight,
      rowKey,
      filterAvailable,
    } = this.props;

    const {
      query,
      rows,
      columns,
      sortingColumns,
      tableHeight,
    } = this.state;

    const searchedRows = compose(
      search.highlighter({
        columns,
        matches: search.matches,
        query,
      }),
      sort.sorter({
        columns,
        sortingColumns,
        sort: orderBy,
        strategy: sort.strategies.byProperty,
      }),
      search.multipleColumns({
        columns,
        query,
      }),
    )(resolve.resolve({columns})(rows));

    const bodyStyle = {};
    if (maxHeight) {
      bodyStyle.maxHeight = maxHeight;
    }

    return (
      <div data-component={'DataTableVirtualized'}>
        {filterAvailable &&
          <Row className={'search-container'}>
            <Col xs={6} className={'pull-right'}>
              <div className={'filter-container'}>
                <label>Search</label>
                <search.Field
                  column={searchColumn}
                  query={query}
                  columns={columns}
                  rows={this._rows}
                  onChange={(query) => {
                    if (searchedRows.length > 0) {
                      this._tableBody.scrollTo(0);
                    }

                    this.setState({query});
                  }}
                />
              </div>
            </Col>
          </Row>
        }
        <Row className={'table-container'}>
          <Col xs={12}>
            {(searchedRows.length < 1) &&
              <p className={'text-center text-danger'}>{noResultText}</p>
            }

            {(searchedRows.length > 0) &&
              <Fragment>
                <Table.Provider
                  className={'table table-striped'}
                  columns={columns}
                  renderers={{
                    body: {
                      wrapper: Virtualized.BodyWrapper,
                      row: Virtualized.BodyRow,
                    },
                  }}
                >
                  <Table.Header />
                  <Virtualized.Body
                    rows={searchedRows}
                    rowKey={rowKey}
                    height={tableHeight}
                    tableHeader={this._tableHeader}
                    ref={(tableBody) => {
                      this._tableBody = tableBody && tableBody.getRef();
                    }}
                    onRow={onRow}
                    style={bodyStyle}
                  />
                </Table.Provider>
              </Fragment>
            }
          </Col>
        </Row>

        <Row className={'info-container'}>
          <Col xs={12}>
            {(optionalFooter) &&
              <div>{optionalFooter}</div>
            }
            {(!optionalFooter) &&
              <p>
                Showing {searchedRows.length} entries

                {(searchedRows.length !== rows.length) &&
                  <Fragment> (filtered from {rows.length} total entries).</Fragment>
                }
              </p>
            }
          </Col>
        </Row>
      </div>
    );
  }
}

DataTableVirtualized.defaultProps = {
  allCellsTransform: false,
  sortHandler: false,
  rowKey: 'id',
  tableHeight: 800,
  searchColumn: 'all',
  noResultText: 'No results found',
  filterAvailable: true,
};

DataTableVirtualized.propTypes = {
  columns: PropTypes.array.isRequired,
  rows: PropTypes.array.isRequired,
  saveEdit: PropTypes.func,
  allCellsTransform: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool,
  ]),
  sortHandler: PropTypes.bool,
  searchColumn: PropTypes.string,
  noResultText: PropTypes.string,
  tableHeight: PropTypes.number,
  onRow: PropTypes.func,
  optionalFooter: PropTypes.object,
  maxHeight: PropTypes.number,
  filterAvailable: PropTypes.bool,
  rowKey: PropTypes.string,
};
